exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "team-request-modal-remove{display:block}team-request-modal-remove .modal-dialog{width:520px}team-request-modal-remove successful-action .description{margin-bottom:50px!important}team-request-modal-remove successful-action .description h1{font-size:18px;font-family:Stag Sans;font-weight:400;margin-bottom:5px}team-request-modal-remove successful-action .description p{margin-bottom:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/dist/cjs.js!./client/app/vacations-absences.module/features/teamRequests/teamRequestsList/teamRequestCard/teamRequestModalRemove/teamRequestModalRemove.scss
// module id = 1233
// module chunks = 0